package org.hs_soft.runmynesto.domain.model.home.product.product_item_model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SpecialPriceItem(
    @SerialName("fromDate")
    val fromDate: String?,
    @SerialName("id")
    val id: String?,
    @SerialName("name")
    val name: String?,
    @SerialName("price")
    val price: List<Double?>?,
    @SerialName("priceInCafe")
    val priceInCafe: List<Double?>?,
    @SerialName("toDate")
    val toDate: String?,
    @SerialName("type")
    val type: Int?,
    @SerialName("typeName")
    val typeName: String?,
    @SerialName("__typename")
    val typename: String?
)